/* TC - Tablero de control-  Presenta lista de Dominios*/
/* TC.ListaPFC - Lista de registros agrupados por PFC*/
/* TC.ListaPFC.Detalles - Tabla de información del PFC simple o agrupado*/

//*react- recursos
  import React, { useState, useCallback, useEffect } from "react";
  import { useRef } from "react";
  import swal2 from "sweetalert2"; //npm install --save sweetalert2
  import { DownloadTableExcel } from "react-export-table-to-excel";

//*componentes-utiles
import CargandoSpin from "../../../../componentes/CargandoSpin";

//*clases
  import ReactTooltip from "react-tooltip";
  //import DatePicker from "react-datepicker";
  import "../../../../css/mdi.css";
  import { Col, Row } from "react-bootstrap";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //'libreria' que cita el bote de basura

//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
  import articulos from "../../../../datos/json/guidelines.json";

///imagenes
  import prevista from "../../../../imagenes/prevista.png";
  import concluido from "../../../../imagenes/concluido.png";
  import enProceso from "../../../../imagenes/enProceso.png";

//*archivos (imagenes y elementos necesarios para la rutina)

//*api's (servicios y store)
  import dashboardServicio from "../../../../api/recursos/dashboard/dashboard.servicio";
  import dashboardStore from "../../../../api/recursos/dashboard/dashboard.store";

  import proposalsServicio from "../../../../api/recursos/proposals/proposals.servicio"; 
  import proposalsStore from "../../../../api/recursos/proposals/proposals.store"; 


//*store's

//*interfaces
interface propsDetalles {
  tokenStore: any;
  catDecisionesStore: any;
  pfcDId: any; //id del dominio
  pfcAId: any; //id del pfc filtrado
  pfcNombre: any;
  pfcArreglo: any;
  recargaTC: any;
  recargaTCListaPFC: any;
  recargaPaginaSSC: any;
  recargaPaginaSSC_Not: any;
}

//*componente
  export default function Detalles(props: propsDetalles) {
    var _ = require("underscore");

    //*api store
      const { pfcDominioStore,
              guardaGetDetailbyUserStore,
              pfcDetallesStore,
              cambiaPfcDominioStore,
              recargaStore,
              generaObjErrorDashboardStore,
      } = dashboardStore((state: any) => ({
            pfcDominioStore: state.pfcDominioStore,
            guardaGetDetailbyUserStore: state.guardaGetDetailbyUserStore,
            pfcDetallesStore: state.pfcDetallesStore,
            cambiaPfcDominioStore: state.cambiaPfcDominioStore,
            recargaStore: state.recargaStore,
            generaObjErrorDashboardStore: state.generaObjErrorDashboardStore,
      }));

      const { guardaGetDetailbyUserPStore, propuestaDetallesStore,
              generaObjErrorProposalsStore, objErrorProposalsStore} =  
          proposalsStore((state:any) =>( { 
              guardaGetDetailbyUserPStore: state.guardaGetDetailbyUserStore,
              propuestaDetallesStore: state.propuestaDetallesStore,
              generaObjErrorProposalsStore: state.generaObjErrorProposalsStore,
              objErrorProposalsStore: state.objErrorProposalsStore
      }));

    //*store's

    //*constantes y variables
      const tableRef = useRef(null);

      let eti = etiquetasSSC.TC;
      let etiRP = etiquetasSSC.RP;
      let x0:any, x1:any, x2:any, x3:any, x4:any, x5:any, x6:any, x7:any, x8:any, x9:any = "";
      let nomArch = props.pfcNombre.replace(" / ", "_");
      nomArch = nomArch.replace(" / ", "_");
      nomArch = nomArch.replace(" ", "");
      nomArch = nomArch.replace(" ", "");
      let nomArchivo = "Es_" + nomArch;
      let nomHoja = nomArch;
      const APP_IMG = process.env.REACT_APP_IMG;
      const APP_NAS = process.env.REACT_APP_NAS + 'analyse/';

    //*useState
      const [swRecarga, setSwRecarga] = useState(false); //usado para remasterizar página padre
      const [swRecarga2, setSwRecarga2] = useState(false); //usado para remasterizar página padre
      const [swRecarga3, setSwRecarga3] = useState(false); //usado para remasterizar página padre
      const [swRecargaTCListaPFCDetalles, setSwRecargaTCListaPFCDetalles] =  useState(false); //usado para remasterizar página padre
      const [cargandoSpin, setCargandoSpin] = useState(false);
      let cuenta = 0;


      const [propuestaDetallesFront, setPropuestaDetallesFront] = useState({}); // guarda la lectura de la propuesta desde proposal

    //*useEffect
   
      useEffect(() => { // uso este puente para recargar elementos del front
        //console.log('--rederizando............');
        setSwRecargaTCListaPFCDetalles(!swRecargaTCListaPFCDetalles);
      }, [swRecarga]);

      useEffect(() => { //la uso porque no queria renderizar el último elemento de props.pfcArreglo
        //console.log('................recarga2', cuenta);
        recargaStore()
        recargaTCListaPFCDetalles();
      }, [swRecarga2]);

      useEffect(() => {
        console.clear();
        //console.log('Detalles - carga....');
        //console.log('----- props.pfcArreglo: ', props.pfcArreglo);
        //console.log('----- nomArchivo: ',nomArchivo);
        //armamos el insumo de la tabla dentro de pfcDominio.pfcAgrupado.arregloDetalles
        //console.log ('...',pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].arregloDetalles.length);
        let pfcArregloLength = props.pfcArreglo.length;
        if (pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].arregloDetalles.length == 0 ) {
            //console.log ('... props.pfcArreglo', props.pfcArreglo.length);
            props.pfcArreglo.map((pfcA: any, indexpfcA: any) => {
              cuenta=0;
              let body = { id: pfcA.id };
              setCargandoSpin(true);
              dashboardServicio.cargaGetDetailbyUser(props.tokenStore, body)
                .then((response: any) => {
                  if (response.status == 200) {
                    //confirma que no hay error
                   
                    guardaGetDetailbyUserStore( response.data, props.pfcDId, props.pfcAId, props.catDecisionesStore ).then(function (datos: any) {
                      console.log('*mandamos el response al store para integrar pfcDetallesVaciaStore' ,  pfcA.id, datos);
                      let paso = datos;
                      cuenta = cuenta + 1
                      ///recargaTCListaPFCDetalles();
                      setSwRecarga(!swRecarga);
                     //console.log('..', pfcA.id, '...', cuenta);
                      if (cuenta == pfcArregloLength) { setSwRecarga2(!swRecarga2) }
                    });
                  }
                  setCargandoSpin(false);
                })
                .catch((ex) => {
                  console.log("--catch - ex (cargaGetDetailbyUser): ", ex.response.status );
                  if (ex.response.status == 404)   //no es error solo no tiene información
                      console.log("nota: no es error solo no tiene información");
                  else
                      generaObjErrorDashboardStore( ex.response, true, "", "", "TC-ListaPFC-Detalles/cargaGetDetailbyUser" );
                  setCargandoSpin(false);  
                });
                
            });
            //setTimeout(function(){ setSwRecargaTCListaPFCDetalles(!swRecargaTCListaPFCDetalles); alert('x');setSwRecarga(!swRecarga); }, 3000);
        }
        else {console.log('no entro ya traigo información...')}
        //recargaTCListaPFCDetalles();
       
        //setSwRecargaTCListaPFCDetalles(!swRecargaTCListaPFCDetalles);
      }, []);


    //*funciones
      const recargaPaginaSSC = () => {  props.recargaPaginaSSC()  }; //ejecuta la función que esta TC y de ahí en Contenido que llama a la renderización de PaginaSSC

      const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() }; //ejecuta la función que esta TC y de ahí en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana

      const recargaTC = () => { props.recargaTC() }; //ejecuta la función que esta TC

      const recargaTCListaPFC = () => { props.recargaTCListaPFC() }; //ejecuta la función que esta TC

      const recargaTCListaPFCDetalles = () => {
        // con esto ejecuto un useEffect, lo uso para renderizar el front
        setSwRecarga(!swRecarga);
      };

      const leePropuestaPorId = (id:any, opcion:any) => { //opciones liga-verFichaCompleta , boton-registra lee el contenido de la propuesta 
        setCargandoSpin(true);
        proposalsServicio.cargaGetDetailbyUser(props.tokenStore, id)
          .then((response:any) => {
            if (response.status==200) {  //confirma que no hay error
                guardaGetDetailbyUserPStore(response.data, id, null, null, 'RPContenido').then( function(propuestaDetallesF:any) { 
                    //console.log('*propuestaDetallesFront: ' , propuestaDetallesFront)
                    setPropuestaDetallesFront(propuestaDetallesF);
                    let origenes=''
                    propuestaDetallesF.origin?.map((o:any, index:any) => (
                       origenes =  origenes 
                                   + "<p class='color-white'>" 
                                   + " <span class='padding-20px' >"
                                   +    "<i class='mdi mdi-checkbox-marked color-azul2 font-size-12'></i>&nbsp;" 
                                   +     o.name + "</span><br/>"
                                   + " <span class='padding-40px'>" + o.specification + "</span>"
                                   + " <br />"         
                                   + "</p>" 
                    ))
                    let procFrec = propuestaDetallesF.processxfrequency[0];
                    let procStatus = procFrec.state_process;
                    let procesos=''
                    propuestaDetallesF.processxfrequency?.map((o:any, index:any) => (
                        procesos =  procesos 
                                    + "<p class='color-white'>" 
                                    + " <span class='padding-20px' >"
                                    +    "<i class='mdi mdi-checkbox-marked color-azul2 font-size-12'></i>&nbsp;" 
                                    +     o.acronym + " / " +     o.processname  + "&nbsp;"
                                    +      "<span class='" + o.clasexEstatusIcono + "'>"
                                    +        o.state_process.pt_state_description
                                    +       "</span>"
                                    +     "</span><br/>"                                        
                                    +  " <br />"         
                                    + "</p>" 
                     ))
                    //console.log('------------procFrec2', procStatus.pt_state_description);
                    let clasexEstatusIcono='';
                    switch ( procStatus.pt_state ) {
                      case 1: clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                      case 2: clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
                      case 3: clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
                      case 4: clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
                      default:clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                    }
                    if (opcion=='liga-verFichaCompleta') { // selecciono liga ver propuesta en tabla, abrimos ventana con la información de la propuesta
                        swal2.fire({
                            //icon: 'warning',
                            //showCancelButton: true,
                            confirmButtonText: "Cerrar",
                            confirmButtonColor: '#3085d6',
                            color: '#fff',
                            background: '#003057',
                            width: "70%",
                            title: 'Propuesta de cambio',
                            html: 
                            "<div>" 
                            + "<p> <span class='color-azul2'>" + etiRP.etiquetas[4].text + "</span>" + propuestaDetallesF.folio + "</p>" 
                            + "<p> <span class='color-azul2'>" + etiRP.etiquetas[5].text + "</span>" + propuestaDetallesF.fecha + "</p>" 
                            + "<p> <span class='color-azul2'>" + etiRP.etiquetas[6].text + "</span> <br/>"
                                    + "<span class='padding-20px'> <i class='mdi mdi-account color-azul2 font-size-12'></i>&nbsp;" 
                                        + propuestaDetallesF.user.name  + "</span> <br/>" 
                                    + "<span class='padding-20px'> <i class='mdi mdi-email color-azul2 font-size-12'></i>&nbsp;" 
                                        + propuestaDetallesF.user.email + "</span> </p>" 
                            + "<p> <span class='color-azul2'>" + etiRP.etiquetas[7].text + "</span> <br/>" 
                                    + "<span class='padding-20px'>" + propuestaDetallesF.description + "</span> </p>"                                     
                            + "<p> <span class='color-azul2'>" + etiRP.etiquetas[8].text + "</span>" 
                                    + "<span class='padding-20px'>" + origenes + "</span> </p>" 
                            + "<p> <span class='color-azul2'>" + etiRP.etiquetas[9].text + "</span>" 
                            + "<span class='padding-20px'>" + procesos + "</span> </p>"                                         
                            + "</div>",
                        })
                    }
                })
            } 
            setCargandoSpin(false);
          })
          .catch((ex) => {
              //ex.response.data.result.errores.map((: any) => (
              //toast.error(err.errorMessage)))
              console.log ("--catch - ex (cargaGetDetailbyUser): ", ex.response.status);
              if (ex.response.status==404) //no es error solo no tiene información
                  console.log('nota: no es error solo no tiene información')
              else
                  generaObjErrorProposalsStore(ex.response, true, '', '', 'RPContenido-Decisions/GetDetailbyUser','RP')
              setCargandoSpin(false);
              recargaPaginaSSC();
          })
          setCargandoSpin(false);
    }

    //**vista
    return (
      <>
        <div className="padding-left-3r">
          <div className="table-responsive">
            
          
            <DownloadTableExcel  filename={nomArchivo}  sheet={nomHoja} currentTableRef={tableRef.current} >
              <button type="button" className="btn-exportar textAlignRight">
                <i className="mdi mdi-file-move-outline"></i> Exportar a Excel
              </button>
            </DownloadTableExcel>

            <br /><br />
            
            {/* pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].arregloDetalles:::: {pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].arregloDetalles.length} */}

            {/* <p className='smaller'>....{pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].arregloDetalles.length}</p>  */}
            {/* tabla que se presenta en front */}
                <table id="tablaMostrar" className="table table-bordered small background-color-white" >

                  <thead id="theadTablaRP" style={{ backgroundColor:"#4c6376", color:"#ffffff", border:"1px solid white", height:"50px", verticalAlign:"top", textAlign:"center" }} >

                    <tr className="background-color-azul7 font-weight-normal align-top" style={{ backgroundColor:"#4c6376", color:"#ffffff", height:"50px", verticalAlign:"top", textAlign:"center" }} >

                      <th rowSpan={2} className="noBR  align-top"> Propuesta(s) </th>

                      <th colSpan={4} className='align-top'> Evidencias de la fase de diseño que serán modificadas por el cambio: 
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span>
                                <button id="btnRT" data-tip data-for="articulo9"> (Art. 9) </button>
                                <ReactTooltip id="articulo9" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 9<br /> {articulos.articles[9].description} <br /> 
                                </ReactTooltip>
                            </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                            (<span>
                                <button id="btnRT" data-tip data-for="articulo19"> (Art.19) </button>
                                <ReactTooltip id="articulo19" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 9<br /> {articulos.articles[9].description} <br /> 
                                </ReactTooltip>
                            </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                            (<span>
                                <button id="btnRT" data-tip data-for="articulo919"> (Art. 9 y 19) </button>
                                <ReactTooltip id="articulo919" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 9<br /> {articulos.articles[9].description} <br /> 
                                  Articulo: 19<br /> {articulos.articles[19].description} <br /> 
                                </ReactTooltip>
                            </span>)
                        }
                      </th>

                      <th rowSpan={2} className='align-top'> Revisión de necesidades <br />
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span>
                                <button id="btnRT" data-tip data-for="articulo10"> (Art. 10) </button>
                                <ReactTooltip id="articulo10" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 10 <br /> {articulos.articles[10].description} <br /> <br /> {articulos.articles[10].description2} <br /><br />
                                </ReactTooltip>
                            </span> )
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                          (<span>
                                <button id="btnRT" data-tip data-for="articulo21"> (Art. 21) </button>
                                <ReactTooltip id="articulo21" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 21 <br /> {articulos.articles[21].description} <br /> <br />
                                </ReactTooltip>
                            </span>)                              
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                          (<span>
                              <button id="btnRT" data-tip data-for="articulo1021">  (Art. 10 y 21) </button>
                              <ReactTooltip id="articulo1021" type="info" place="right" multiline >
                                {articulos.articles[0].ch} <br /> <br />
                                Articulo: 10 <br /> {articulos.articles[10].description} <br /> <br /> {articulos.articles[10].description2} <br /><br />
                                Articulo: 21 <br /> {articulos.articles[21].description} <br /> <br />
                              </ReactTooltip>
                            </span>)                              
                        }
                      </th>

                      <th rowSpan={2} className='align-top'> Relación de cambios: <br />
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span>
                                <button id="btnRT" data-tip data-for="articulo12">  (Art. 12)  </button>
                                <ReactTooltip id="articulo12" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 12 <br /> {articulos.articles[12].description} <br /> <br />
                                </ReactTooltip>
                              </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                            (<span>
                                <button id="btnRT" data-tip data-for="articulo21a">  (Art. 21)  </button>
                                <ReactTooltip id="articulo21a" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 21 <br /> {articulos.articles[21].description} <br /> <br />
                                </ReactTooltip>
                            </span>) 
                        } 
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                            (<span>
                                <button id="btnRT" data-tip data-for="articulo1221">  (Art. 12 y 21)  </button>
                                <ReactTooltip id="articulo1221" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 12 <br /> {articulos.articles[12].description} <br /> <br />
                                  Articulo: 21 <br /> {articulos.articles[21].description} <br /> <br />
                                </ReactTooltip>
                            </span>) 
                        } 
                      </th>

                      <th rowSpan={2} className='align-top'>
                      { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                        (<>
                            Plan de acción: <br />
                            <span>
                              <button id="btnRT" data-tip data-for="articulo15"> (Art. 15) </button>
                              <ReactTooltip id="articulo15" type="info" place="right" multiline >
                                {articulos.articles[0].ch} <br /> <br />
                                Articulo: 15 <br /> {articulos.articles[15].description} <br /> <br />
                              </ReactTooltip>
                            </span>
                        </>)
                      }
                      { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                        (<>
                            Informe de instrumentación: <br />
                            <span>
                              <button id="btnRT" data-tip data-for="articulo24">  (Art. 24) </button>
                              <ReactTooltip id="articulo24" type="info" place="right" multiline >
                                {articulos.articles[0].ch} <br /> <br />
                                Articulo: 24 <br /> {articulos.articles[24].description} <br /> <br />
                              </ReactTooltip>
                            </span>
                        </>)
                      }
                      { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                        (<>
                          Plan de acción: <br />
                          <span>
                            <button id="btnRT" data-tip data-for="articulo15a"> (Art. 15) </button>
                            <ReactTooltip id="articulo15a" type="info" place="right" multiline >
                              {articulos.articles[0].ch} <br /> <br />
                              Articulo: 15 <br /> {articulos.articles[15].description} <br /> <br />
                            </ReactTooltip>
                          </span>
                          &nbsp; / <br /><br />
                          Informe de instrumentación: <br />
                          <span>
                            <button id="btnRT" data-tip data-for="articulo24a">  (Art. 24) </button>
                            <ReactTooltip id="articulo24a" type="info" place="right" multiline >
                              {articulos.articles[0].ch} <br /> <br />
                              Articulo: 24 <br /> {articulos.articles[24].description} <br /> <br />
                            </ReactTooltip>
                          </span>
                        </>)
                      }
                      </th>
                    </tr>
                    
                    <tr className="background-color-azul7 font-weight-normal align-top">

                      <th className='align-top'> Evidencias: <br />
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span>
                              <button id="btnRT" data-tip data-for="articulo9a">  (Art. 9) </button>
                              <ReactTooltip id="articulo9a" type="info" place="right" multiline >
                                {articulos.articles[0].ch} <br /> <br />
                                Articulo: 9<br /> {articulos.articles[9].description} <br /> <br />
                              </ReactTooltip>
                            </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                            (<span>
                              <button id="btnRT" data-tip data-for="articulo19a">  (Art. 19) </button>
                              <ReactTooltip id="articulo19a" type="info" place="right" multiline >
                                {articulos.articles[0].ch} <br /> <br />
                                Articulo: 19 <br /> {articulos.articles[19].description} <br /> <br />
                              </ReactTooltip>
                            </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                            (<span>
                              <button id="btnRT" data-tip data-for="articulo919a">  (Art. 9 y 19) </button>
                              <ReactTooltip id="articulo919a" type="info" place="right" multiline >
                                {articulos.articles[0].ch} <br /> <br />
                                Articulo: 9<br /> {articulos.articles[9].description} <br /> <br />
                                Articulo: 19 <br /> {articulos.articles[19].description} <br /> <br />
                              </ReactTooltip>
                            </span>)
                        }
                      </th>

                      <th className='align-top'>Características: <br />
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                              (<span>
                                <button id="btnRT" data-tip data-for="articulo12a">  (Art. 12) </button>
                                <ReactTooltip id="articulo12a" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 12 <br /> {articulos.articles[12].description} <br /> <br />
                                </ReactTooltip>
                              </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                              (<span>
                                <button id="btnRT" data-tip data-for="articulo21a">  (Art. 21) </button>
                                <ReactTooltip id="articulo21a" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 21 <br /> {articulos.articles[21].description} <br /> <br />
                                </ReactTooltip>
                              </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                              (<span>
                                <button id="btnRT" data-tip data-for="articulo1221a">  (Art. 12 y 21) </button>
                                <ReactTooltip id="articulo1221a" type="info" place="right" multiline >
                                  {articulos.articles[0].ch} <br /> <br />
                                  Articulo: 12 <br /> {articulos.articles[12].description} <br /> <br />
                                  Articulo: 21 <br /> {articulos.articles[21].description} <br /> <br />
                                </ReactTooltip>
                              </span>)
                        }
                      </th>

                      <th className='align-top'> Pruebas a realizar: <br />
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                          (<span>
                            <button id="btnRT" data-tip data-for="articulo13">  (Art. 13) </button>
                            <ReactTooltip id="articulo13" type="info" place="right" multiline >
                              {articulos.articles[0].ch} <br /> <br />
                              Articulo: 13 <br /> {articulos.articles[13].description} <br /> <br />
                              {articulos.articles[13].description2} <br />
                            </ReactTooltip>
                          </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                          (<span>
                            <button id="btnRT" data-tip data-for="articulo23">  (Art. 23) </button>
                            <ReactTooltip id="articulo23" type="info" place="right" multiline >
                              {articulos.articles[0].ch} <br /> <br />
                              Articulo: 23 <br /> {articulos.articles[23].description} <br /> <br />
                            </ReactTooltip>
                          </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                          (<span>
                            <button id="btnRT" data-tip data-for="articulo1323">  (Art. 13 y 23) </button>
                            <ReactTooltip id="articulo1323" type="info" place="right" multiline >
                              {articulos.articles[0].ch} <br /> <br />
                              Articulo: 13 <br /> {articulos.articles[13].description} <br /> <br />
                              {articulos.articles[13].description2} <br /><br />
                              Articulo: 23 <br /> {articulos.articles[23].description} <br /> <br />
                            </ReactTooltip>
                          </span>)
                        }
                      </th>

                      <th className='align-top'> Reportes de pruebas: <br />
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span>
                              <button id="btnRT" data-tip data-for="articulo14">  (Art. 14) </button>
                              <ReactTooltip id="articulo14" type="info" place="right" multiline >
                                {articulos.articles[0].ch} <br /> <br />
                                Articulo: 14 <br /> {articulos.articles[14].description} <br /> <br />
                              </ReactTooltip>
                          </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                            (<span>
                              <button id="btnRT" data-tip data-for="articulo23a">  (Art. 23) </button>
                              <ReactTooltip id="articulo23a" type="info" place="right" multiline >
                                {articulos.articles[0].ch} <br /> <br />
                                Articulo: 23 <br /> {articulos.articles[23].description} <br /> <br />
                              </ReactTooltip>
                          </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                            (<span>
                              <button id="btnRT" data-tip data-for="articulo14">  (Art. 14 y 23) </button>
                              <ReactTooltip id="articulo14" type="info" place="right" multiline >
                                {articulos.articles[0].ch} <br /> <br />
                                Articulo: 14 <br /> {articulos.articles[14].description} <br /> <br />
                                Articulo: 23 <br /> {articulos.articles[23].description} <br /> <br />
                              </ReactTooltip>
                          </span>)
                        }
                      </th>
                    </tr>
                  </thead>
                  {pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].arregloDetalles?.map((pfcAD: any, indexPfcAD: any) => (
                    <>
                      <tbody>
                      
                            {/* Prevista / No previstas  - Concluido / En proceso de documentación */}
                            <tr className="background-color-azul2">
                              <td colSpan={8} style={{ border: "1px solid white", fontWeight: "600" }} >
                                <p>
                                  {/* {pfcAD.id} */}
                                  <span dangerouslySetInnerHTML={{  __html: pfcAD.textoDecision, }} ></span>
                                  &nbsp;&nbsp;&nbsp;
                                  {pfcAD.sent 
                                    ? (<>
                                        <span className="color-verde2">
                                          <i className="mdi mdi-email-check-outline "></i> Concluido
                                        </span>
                                      </>)
                                    : (<>
                                        <span className="color-naranja2">
                                          <i className="mdi mdi-file-document "></i>En proceso de documentación
                                        </span>
                                      </>)
                                  }
                                </p>
                              </td>
                            </tr>

                            {pfcAD.evidence?.map((evi: any, indexEvi: any) => (
                              <>
                                <tr>
                                  {/* propuesta */}
                                  {indexEvi == 0 &&
                                    (<>
                                      <td rowSpan={pfcAD.numEvidencias} >
                                        {pfcAD.proposal?.map((prop: any, indexProp: any) => (
                                            <>  {/* <p>{prop.id}</p>  */}
                                              <p> <a  title='Abre ventana con la información de la propuesta de cambio' onClick={ () => leePropuestaPorId(prop.id, 'liga-verFichaCompleta') } className="text-link cursorHand noBR">
                                                    {prop.id}
                                                    </a> </p> 
                                            </>
                                          )
                                        )}
                                      </td>
                                    </>)
                                  }

                                  {/* evidencia */}
                                  <td>  <p>  <i className="mdi mdi-checkbox-marked colorBlue1 Font10"></i> {evi.name} </p>  </td>

                                  {/* caracteristicas */}
                                  <td>
                                    {evi.feature?.map((car: any, indexCarac: any) => (
                                      <>  <p>  <i className="mdi mdi-checkbox-marked colorBlue1 Font10"></i> {car.name} </p>  </>
                                    ))}
                                  </td>

                                  {/* pruebas a realizar */}
                                  <td>
                                    {evi.proof?.map((pru: any, indexCarac: any) => (
                                      <>  <p> <i className="mdi mdi-checkbox-marked colorBlue1 Font10"></i> {pru.name} <br />  
                                              &nbsp;&nbsp;&nbsp;&nbsp;  {pru.other} </p>  
                                      </>
                                    ))}
                                  </td>

                                  {indexEvi == 0 &&
                                    (<>
                                      {/*reporte de pruebas y/o justificación */}
                                      <td rowSpan={pfcAD.numEvidencias}>
                                        {pfcAD.swProof && (
                                          <>
                                            <span className="small color-azul3"> Reporte(s): </span>
                                            <br />
                                          </>
                                        )}
                                      
                                        {pfcAD.files?.map((arch: any, indexProp: any) => (
                                          (x5= APP_NAS + arch.path + arch.name),
                                          (<>
                                            {arch.classified == "PROOF" && 
                                              (<>
                                                <span title={arch.name} className="cursorHand smaller" >
                                                  <a href={x5} target="_blank" className="text-link">
                                                    <i className="mdi mdi-checkbox-marked colorBlue1 Font10"></i>
                                                    {arch.nombreCorto}
                                                  </a>
                                                </span>
                                                <br />
                                              </>)
                                            }
                                          </>)
                                        ))}

                                        {pfcAD.swJustify && (
                                          <>
                                            
                                            <span className="small color-azul3">
                                              Justificación(es):
                                            </span>
                                            <br />
                                          </>
                                        )}
                                        {pfcAD.files?.map((arch: any, indexProp: any) => (
                                          (x6= APP_NAS + arch.path + arch.name),
                                          (<>
                                            {arch.classified == "JUSTIFY" && 
                                              (<>
                                                <span title={arch.name} className="cursorHand smaller" >
                                                  <a href={x6} target="_blank" className="text-link">
                                                    <i className="mdi mdi-checkbox-marked colorBlue1 Font10"></i>
                                                    {arch.nombreCorto}
                                                  </a>
                                                </span>
                                                <br />
                                              </>)
                                            }
                                          </>)
                                        ))}
                                      </td>

                                      {/*revisión de necesidades */}
                                      <td rowSpan={pfcAD.numEvidencias}>
                                        {pfcAD.files?.map((arch: any, indexProp: any) => (
                                          (x7= APP_NAS + arch.path + arch.name),
                                          (<>
                                            {arch.classified == "NR" && 
                                              (<>
                                                <span title={arch.name} className="cursorHand smaller" >
                                                  <a href={x7} target="_blank" className="text-link">
                                                    <i className="mdi mdi-checkbox-marked colorBlue1 Font10"></i>
                                                    {arch.nombreCorto}
                                                  </a>
                                                </span>
                                                <br />
                                              </>)
                                            }
                                          </>)
                                        ))}
                                      </td>

                                      {/* relación de cambios */}
                                      <td rowSpan={pfcAD.numEvidencias}>
                                        {pfcAD.files?.map((arch: any, indexProp: any) => (
                                          (x8= APP_NAS + arch.path + arch.name),
                                          (<>
                                            {arch.classified == "CR" && 
                                              (<>
                                                <span title={arch.name} className="cursorHand smaller" >
                                                  <a href={x8} target="_blank" className="text-link">
                                                    <i className="mdi mdi-checkbox-marked colorBlue1 Font10"></i>
                                                    {arch.nombreCorto}
                                                  </a>
                                                </span>
                                                <br />
                                              </>)
                                            }
                                          </>)
                                        ))}
                                      </td>

                                      {/* plan de acción  / informe de instrumentación */}
                                      <td rowSpan={pfcAD.numEvidencias}>
                                        {pfcAD.files?.map((arch: any, indexProp: any) => (
                                          (x9= APP_NAS + arch.path + arch.name),
                                          (<>
                                            {arch.classified == "API" && 
                                              (<>
                                                <span title={arch.name} className="cursorHand smaller" >
                                                  <a href={x9} target="_blank" className="text-link">
                                                    <i className="mdi mdi-checkbox-marked colorBlue1 Font10"></i>
                                                    {arch.nombreCorto}
                                                  </a>
                                                </span>
                                                <br />
                                              </>)
                                            }
                                          </>)
                                        ))}
                                      </td>
                                    </>)
                                  }
                                </tr>
                              </>
                            ))}
                      </tbody>
                    </>
                  ))}

                </table>

            
            {/* tabla oculta para exportar   */}
            {/* <p>....{pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision}</p> */}

              <table ref={tableRef} id="tablaOcultar" className="table table-bordered small background-color-white" >
                <thead id="tid" style={{ backgroundColor:"#4c6376", color:"#ffffff", border:"1px solid white", height:"50px", verticalAlign:"top", textAlign:"center" }} className="theadExc" >
                  
                  <tr style={{ height: "50px", verticalAlign: "top", textAlign: "center" }} >
                    
                    <td rowSpan={2} style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#4c6376", color: "#ffffff" }} className="theadExc" >
                      <span>Propuesta(s):</span>
                    </td>

                    <td colSpan={4} style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#4c6376", color: "#ffffff" }} >
                       <span> Evidencias de la fase de diseño que serán modificadas por el cambio: </span>
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span> (Art. 9)  </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                            (<span> (Art.19)  </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                            (<span>  (Art. 9 y 19)  </span>)
                        }
                    </td>

                    <td rowSpan={2} style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#4c6376", color: "#ffffff" }} >
                      <span> Revisión de necesidades: <br />  </span>
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span> (Art. 10) </span> )
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                            (<span>  (Art. 21)  </span>)                              
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                           (<span> (Art. 10 y 21) </span>)                              
                        }
                    </td>
  
                    <td rowSpan={2} style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#4c6376", color: "#ffffff" }} >
                      <span> Relación de cambios: <br /> </span>
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span>  (Art. 12) </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                            (<span> (Art. 21) </span>) 
                        } 
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                            (<span> (Art. 12 y 21) </span>) 
                        }
                    </td>

                    <td rowSpan={2} style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#4c6376", color: "#ffffff" }} >
                      <span>
                      { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                        (<> Plan de acción: <br /> <span>  (Art. 15)  </span></>)
                      }
                      { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                        (<>Informe de instrumentación: <br /> <span>  (Art. 24) </span></>)
                      }
                      { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                        (<>
                          Plan de acción: <br /> <span>  (Art. 15) </span>
                          &nbsp; / <br /><br />
                          Informe de instrumentación: <br /> <span> (Art. 24)  </span>
                        </>)
                      }
                      </span>
                    </td>

                  </tr>

                  <tr style={{ height: "50px", verticalAlign: "top", textAlign: "center" }} >

                    <td style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#4c6376", color: "#ffffff" }} >
                      <span> Evidencias: <br /></span>
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span>  (Art. 9)  </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                            (<span> (Art. 19)  </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                            (<span> (Art. 9 y 19)  </span>)
                        }
                    </td>
                  
                    <td style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#4c6376", color: "#ffffff" }} >
                      <span>  Características: <br /></span>
                      { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                              (<span> (Art. 12)  </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                              (<span> (Art. 21) </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                              (<span> (Art. 12 y 21) </span>)
                        }
                    </td>
             
                    <td style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#4c6376", color: "#ffffff" }} >
                      <span>   Pruebas a realizar: <br /></span>
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                          (<span>  (Art. 13)  </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                          (<span> (Art. 23)  </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                          (<span> (Art. 13 y 23) </span>)
                        }
                    </td>
                   

                    <td style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#4c6376", color: "#ffffff" }} >
                      <span>  Reportes de pruebas: <br /> </span>
                      { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 2 &&
                            (<span> (Art. 14)  </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 3 &&
                            (<span> (Art. 23) </span>)
                        }
                        { pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].swDecision == 23 &&
                            (<span> (Art. 14 y 23) </span>)
                        }
                    </td>

                  </tr>
                </thead>

                <tbody>
                  {pfcDominioStore[props.pfcDId].pfcAgrupado[props.pfcAId].arregloDetalles?.map((pfcAD: any, indexPfcAD: any) => (
                      ((x0 = APP_IMG + "prevista.png"),
                      (x1 = APP_IMG + "concluido.png"),
                      (x2 = APP_IMG + "enproceso.png"),
                      (x3 = APP_IMG + "checkT.png")),
                      (<>
                          {/* Prevista & No prevista & Concluido & En proceso */}
                          <tr style={{ verticalAlign: "top", height:"42px" }}>                          
                              {pfcAD.textoDecisionExcel == "Prevista No prevista " 
                                ? (<>
                                    <td colSpan={1} className="colorG" style={{ border: "1px solid white", fontWeight: "600", backgroundColor: "#dee2e6"  }} >  
                                      <img src={x0} />&nbsp;&nbsp;&nbsp; Prevista <br/>
                                      <img src={x0} />&nbsp;&nbsp;&nbsp; No prevista
                                    </td>
                                  </>)
                                : (<>
                                    <td colSpan={1} className="colorG" style={{ border: "1px solid white", fontWeight: "600", backgroundColor: "#dee2e6" }} > 
                                        <img src={x0} />&nbsp;&nbsp;&nbsp;{pfcAD.textoDecisionExcel}
                                    </td>
                                  </>)
                              }
                              {pfcAD.sent 
                                ? (<>
                                    <td colSpan={1} className="colorG"  style={{ border: "1px solid white", fontWeight: "600",  backgroundColor: "#dee2e6" }} > 
                                      <img src={x1}  />&nbsp;&nbsp;&nbsp;Concluido
                                    </td>
                                  </>)
                                : (<>   
                                    <td colSpan={1} className="colorG" style={{ border: "1px solid white", fontWeight: "600", backgroundColor: "#dee2e6" }} >                            
                                        <img src={x2} />&nbsp;&nbsp;&nbsp; En proceso de documentación
                                    </td>
                                  </>)
                              }
                              <td colSpan={6} className="colorG" style={{ border: "1px solid white", fontWeight: "600", backgroundColor: "#dee2e6" }}>
                              </td>
                          </tr>



                          {/* contenido de la tabla */}
                          {pfcAD.evidence?.map((evi: any, indexEvi:any) => (
                            <>
                              <tr style={{ verticalAlign: "top" }}>
                                
                                {/* propuesta */}
                                {indexEvi == 0 && 
                                  (<>
                                    <td rowSpan={pfcAD.numEvidencias} style={{ backgroundColor:"#ffff",  border: "1px solid #dee2e6" }}>
                                      {pfcAD.proposal?.map((prop: any, indexProp: any) => (
                                          <>  <p>{prop.id}</p> </>
                                        )
                                      )}
                                    </td>
                                  </>)
                                }

                                {/* evidencia */}
                                <td>
                                  <p> <img src={x3}  />&nbsp;&nbsp;&nbsp;&nbsp; {evi.name}  </p>
                                </td>

                                {/* caracteristicas */}
                                <td >
                                  {evi.feature?.map((car: any, indexCarac: any) => (
                                    <>
                                      <p> <img src={x3}  /> &nbsp;&nbsp;&nbsp;&nbsp;{car.name}</p>
                                    </>
                                  ))}
                                </td>

                                {/* pruebas a realizar */}
                                <td >
                                  
                                  {evi.proof?.map((pru: any, indexCarac: any) => (
                                    <>
                                    <p> <img src={x3}  /> &nbsp;&nbsp;&nbsp;&nbsp;{pru.name} <br />&nbsp;&nbsp;&nbsp;&nbsp;{pru.other}</p>
                                    </>
                                  ))}
                                </td>

                                {indexEvi == 0 &&
                                  (<>
                                    {/*reporte de pruebas y/o justificación */}
                                    <td rowSpan={pfcAD.numEvidencias} style={{ verticalAlign: "top", backgroundColor:"#ffff",  border: "1px solid #dee2e6" }}>
                                      {pfcAD.swProof && 
                                        (<>
                                            <span className="small color-azul3"> Reporte(s): </span> <br />
                                        </>)
                                      }

                                    
                                      {pfcAD.files?.map((arch: any, indexProp: any) => (
                                        (x5= APP_NAS + arch.path + arch.name),
                                        (<>
                                          {arch.classified == "PROOF" && 
                                            (<>
                                              <span title={arch.name}  >
                                                <img src={x3}  /> &nbsp; &nbsp;&nbsp;&nbsp;
                                                <a href={x5} target="_blank" className="text-link"> {arch.nombreCorto} </a>
                                              </span>
                                              <br />
                                            </>)
                                          }
                                        </>)
                                      ))}

                                      {pfcAD.swJustify && (
                                        <>
                                          
                                          <span className="small color-azul3">
                                            Justificación(es):
                                          </span>
                                          <br />
                                        </>
                                      )}
                                      {pfcAD.files?.map((arch: any, indexProp: any) => (
                                        (x6= APP_NAS + arch.path + arch.name),
                                        (<>
                                          {arch.classified == "JUSTIFY" && 
                                            (<>
                                              <span title={arch.name} >
                                                <img src={x3}  />&nbsp; &nbsp;&nbsp;&nbsp;
                                                <a href={x6} target="_blank" className="text-link">{arch.nombreCorto}</a>
                                              </span>
                                              <br />
                                            </>)
                                          }
                                        </>)
                                      ))}
                                    </td>

                                    {/*revisión de necesidades */}
                                    <td rowSpan={pfcAD.numEvidencias}>
                                      {pfcAD.files?.map((arch: any, indexProp: any) => (
                                        (x7= APP_NAS + arch.path + arch.name),
                                        (<>
                                          {arch.classified == "NR" && 
                                            (<>
                                              <span title={arch.name} >
                                                <img src={x3}  /> &nbsp; &nbsp;&nbsp;&nbsp;
                                                <a href={x7} target="_blank" className="text-link"> {arch.nombreCorto} </a>
                                              </span>
                                              <br />
                                            </>)
                                          }
                                        </>)
                                      ))}
                                    </td>

                                    {/* relación de cambios */}
                                    <td rowSpan={pfcAD.numEvidencias}>
                                      {pfcAD.files?.map((arch: any, indexProp: any) => (
                                        (x8= APP_NAS + arch.path + arch.name),
                                        (<>
                                          {arch.classified == "CR" && 
                                            (<>
                                              <span title={arch.name} >
                                                <img src={x3}  /> &nbsp; &nbsp;&nbsp;&nbsp;
                                                <a href={x8} target="_blank" className="text-link"> {arch.nombreCorto} </a>
                                              </span>
                                              <br />
                                            </>)
                                          }
                                        </>)
                                      ))}
                                    </td>

                                    {/* plan de acción  / informe de instrumentación */}
                                    <td rowSpan={pfcAD.numEvidencias}>
                                      {pfcAD.files?.map((arch: any, indexProp: any) => (
                                        (x9= APP_NAS + arch.path + arch.name),
                                        (<>
                                          {arch.classified == "API" && 
                                            (<>
                                              <span title={arch.name}>
                                                <img src={x3}  /> &nbsp; &nbsp;&nbsp;&nbsp;
                                                <a href={x9} target="_blank" className="text-link"> {arch.nombreCorto} </a>
                                              </span>
                                              <br />
                                            </>)
                                          }
                                        </>)
                                      ))}
                                    </td>
                                  </>)
                                }
                              </tr>
                            </>
                          ))}
                      </>)
                    )
                  )}
                </tbody>
              </table>
           

          </div>
        </div>

       
        
        {/* ventana de carga con spin que se abre mientras lee el api */}
        {cargandoSpin && <CargandoSpin />}
      </>
    );
  }
